// Formata o login (userId) inserindo o ponto após o CPF (11 dígitos).
// Ex.: "392281038171" -> "39228103817.1"; "39228103817337" -> "39228103817.337".
// Mesmo comportamento do login da plataforma (granapix-frontend).
const usernameFormatter = (value: string): string => {
  const cleanValue = value.replace(/\D/g, "");

  // Assim que o CPF (11 dígitos) é completado, já mostra o ponto para deixar claro
  // que ainda falta o id do corban/promotora (login = CPF + "." + id).
  if (cleanValue.length >= 11) {
    const cpf = cleanValue.slice(0, 11);
    const extra = cleanValue.slice(11, 20);
    return `${cpf}.${extra}`;
  }

  return cleanValue;
};

export { usernameFormatter };
